import { handleService } from './common'

export default {
  GetPayTable (data) {
    let url = '/api/Device/GetPayEquListByPgae'
    // debugger
    return handleService(url, data)
  },

  // 故障状态查询
  GetStatus (data) {
    console.log(data)
  }
}
